module.exports = __webpack_public_path__ + "static/media/imagem37.16803f99.jpeg";